// Empty/automatic preserves the old KV > Lottie > image priority.
export function visualMode(entry) {
  const requested = entry?.visualType || 'auto'
  if (['image', 'kv', 'lottie'].includes(requested)) return requested
  if (entry?.conversationBox?.length) return 'kv'
  if (entry?.lottieFileDesktop?.[0]?.url || entry?.lottieFileMobile?.[0]?.url) return 'lottie'
  return 'image'
}

export function hasLottie(entry) {
  return !!(entry?.lottieFileDesktop?.[0]?.url || entry?.lottieFileMobile?.[0]?.url)
}

// Automatic must retain the carousel's existing video + Lottie layering when both are saved.
export function showHeroVideo(entry) {
  return entry?.visualType !== 'lottie' && !(visualMode(entry) === 'kv' && entry?.conversationBox?.length)
}
